module.exports={hackathon:"HackGT 7",cms:"https://cms.hack.gt/admin/api",repo:"https://www.github.com/HackGT/hackgt7-website"};